export enum DASHBOARD_BLOCK_TYPES {
    CLIENTS = 'clients',
    EMPLOYEES = 'employees',
    OPERATIONS = 'operations',
}